import React, { Component } from "react";

import $ from "jquery";
import LoggoSkywatch from "images/custom/logoSkywatch.svg";
import LogoFacebook from "images/custom/logo-facebook.svg";
import LogoLine from "images/custom/logo-line.svg";
import LogoYT from "images/custom/logo-yt.svg";
require("./Footer.css");

class Footer extends Component {
  componentDidMount = () => {
    $(".footer-logo").click(() => {
      window.open("https://www.skywatch24.com/abountus-tw", "_blank");
    });
  };

  onClickEmail = () => {
    window.gtag("event", "click", {
      event_category: "email",
      event_label: "",
      value: 0
    });
  };

  onClickLine = () => {
    window.gtag("event", "click", {
      event_category: "line",
      event_label: "",
      value: 0
    });
  };

  onClickPhone = () => {
    window.gtag("event", "click", {
      event_category: "call",
      event_label: "",
      value: 0
    });
    window.fbq("track", "Contact");
  };

  render() {
    return (
      <div id="row12">
        <div className="pc1440">
          <div className="footer-box">
            <div className="footer-information-box">
              <img alt="" src={LoggoSkywatch} className="footer-logo" />
              <div>
                <p
                  className="footer-information"
                  onClick={() => {
                    this.onClickEmail();
                  }}
                >
                  <a href="mailto:sales@skywatch24.com">sales@skywatch24.com</a>
                </p>
                <p
                  className="footer-information"
                  onClick={() => {
                    this.onClickPhone();
                  }}
                >
                  <a href="tel:+886-2-2888-2212">TEL：02 2888-2212</a>
                </p>
                <p className="footer-information">
                  客服時間：週一至週五 09:00 - 18:00
                </p>
              </div>
            </div>
            <div className="footer-icon-box">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/SkywatchInnovation/"
              >
                <img alt="" src={LogoFacebook} className="footer-icon" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://nav.cx/1hqjtRM"
                onClick={() => {
                  this.onClickLine();
                }}
              >
                <img alt="" src={LogoLine} className="footer-icon" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/user/SkywatchInc"
              >
                <img alt="" src={LogoYT} className="footer-icon" />
              </a>
            </div>
          </div>
          <div className="footer-floor-box">
            <p className="footer-floor">
              © {new Date().getFullYear()} Skywatch Inc. All rights reserved
              <br />
              Illustration by{" "}
              <a href="https://icons8.com/illustrations/author/5dbc313c01d03600167c33bc">
                Thierry Fousse{" "}
              </a>
              from <a href="https://icons8.com/illustrations">Ouch!</a>
            </p>
          </div>
        </div>
        <div className="mobile">
          <div className="footer-box">
            <div className="footer-information-box">
              <img alt="" src={LoggoSkywatch} className="footer-logo" />
              <div>
                <p
                  className="footer-information"
                  onClick={() => {
                    this.onClickEmail();
                  }}
                >
                  <a href="mailto:sales@skywatch24.com">sales@skywatch24.com</a>
                </p>
                <p
                  className="footer-information"
                  onClick={() => {
                    this.onClickPhone();
                  }}
                >
                  <a href="tel:+886-2-2888-2212">TEL：02 2888-2212</a>
                </p>
                <p className="footer-information">
                  客服時間：週一至週五 09:00 - 18:00
                </p>
              </div>
            </div>
            <div className="footer-icon-box">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/SkywatchInnovation/"
              >
                <img alt="" src={LogoFacebook} className="footer-icon" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://nav.cx/1hqjtRM"
                onClick={() => {
                  this.onClickLine();
                }}
              >
                <img alt="" src={LogoLine} className="footer-icon" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/user/SkywatchInc"
              >
                <img alt="" src={LogoYT} className="footer-icon" />
              </a>
            </div>
          </div>
          <div className="footer-floor-box">
            <p className="footer-floor">
              © {new Date().getFullYear()} Skywatch Inc. All rights reserved
              <br />
              Illustration by{" "}
              <a href="https://icons8.com/illustrations/author/5dbc313c01d03600167c33bc">
                Thierry Fousse{" "}
              </a>
              from <a href="https://icons8.com/illustrations">Ouch!</a>
            </p>
          </div>
        </div>
        <div className="pc1024">
          <div className="footer-box">
            <div className="footer-information-box">
              <img alt="" src={LoggoSkywatch} className="footer-logo" />
              <div>
                <p
                  className="footer-information"
                  onClick={() => {
                    this.onClickEmail();
                  }}
                >
                  <a href="mailto:sales@skywatch24.com">sales@skywatch24.com</a>
                </p>
                <p
                  className="footer-information"
                  onClick={() => {
                    this.onClickPhone();
                  }}
                >
                  <a href="tel:+886-2-2888-2212">TEL：02 2888-2212</a>
                </p>
                <p className="footer-information">
                  客服時間：週一至週五 09:00 - 18:00
                </p>
              </div>
            </div>
            <div className="footer-icon-box">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/SkywatchInnovation/"
              >
                <img alt="" src={LogoFacebook} className="footer-icon" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://nav.cx/1hqjtRM"
                onClick={() => {
                  this.onClickLine();
                }}
              >
                <img alt="" src={LogoLine} className="footer-icon" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.youtube.com/user/SkywatchInc"
              >
                <img alt="" src={LogoYT} className="footer-icon" />
              </a>
            </div>
          </div>
          <div className="footer-floor-box">
            <p className="footer-floor">
              © {new Date().getFullYear()} Skywatch Inc. All rights reserved
              <br />
              Illustration by{" "}
              <a href="https://icons8.com/illustrations/author/5dbc313c01d03600167c33bc">
                Thierry Fousse{" "}
              </a>
              from <a href="https://icons8.com/illustrations">Ouch!</a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
